/**
 * Objects
 *
 * @module
 */

/**
 * Object deep set. Taken from https://github.com/klaemo/deep-set
 *
 * @param {object} destination
 * @param {string} path
 * @param {any} value
 * @return {void}
 */
export function deepSet(destination, path, value) {
    let current = destination;

    path.split('.').forEach((part) => {
        if (typeof current[part] !== 'object') {
            current[part] = {};
        }
        current = current[part];
    });

    current[path.split('.').pop()] = value;
}
